export default "__VITE_ASSET__DNkmCTyQ__"